import { Fragment, useEffect, useState } from "react";
import { Button, Modal } from "src/components";
import SmartForm from "src/container/smart-form.component";
import { getAllLinkTypesDetails } from "src/services/counter-api";
import { getCounterTypes } from "src/services/common-api";
import { getCompanyList, getDivisionList, getStateList } from "src/services/order-api";
import { getCounterDetails, getProductDetails, getStockistDetails } from "src/services/reports-api";
import { addOrderTypeException } from "src/features/fields/services/order-type-exception-api";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { generateUniqueID } from "src/constants/functions";
import { toast } from "src/hooks/useToast";

const orderTypes = [{ label: "Regular Order", value: 1 },
{ label: "Supply Against Order - No Replenishment", value: 2 },
{ label: "Credit Note - No Replenishment", value: 3 }];

const OrderTypeExceptionForm = ({ onClose }: { onClose: () => void }) => {

  const [companyList, setCompanyList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [linkTypeList, setLinkTypeList] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [counterList, setCounterList] = useState([]);
  const [itemList, setItemList] = useState([]);
  const [stockistList, setStockistList] = useState([]);
  const [loading, setLoading] = useState(false)

  const getCompanyCode = () =>
    (formInstance.getValues("company") as any)?.code;

  const getDivisionCode = () =>
    (formInstance.getValues("division") as any)?.company_divisioncode;

  useEffect(() => {
    if (!companyList?.length) {
      getCompanyList()
        .then((res) => setCompanyList(res?.data))
        .catch((err) => console.log(err));

    }
    if (!stateList?.length) {
      getStateList()
        .then((res) => setStateList(res?.data?.data))
        .catch((err) => console.log(err));
    }

    getAllLinkTypesDetails("?divisionMaster=true")
      .then((res) => {
        console.log(res.data)
        setLinkTypeList(res?.data)
      })
      .catch((err) => console.log(err));

    const fetchCounterTypes = async () => {
      try {
        const response = await getCounterTypes("?PUC=true");
        setModuleList(response?.data?.data || []);
      } catch (error) {
        console.error(error);
      }
    };

    fetchCounterTypes();
  }, []);

  const fetchDivision = async (value: string) => {
    console.log("fetchDivision")
    const company_code = getCompanyCode();
    console.log("company_code", company_code)
    if (!company_code) return [];

    try {
      const res = await getDivisionList({
        company_code,
        search: value,
      });
      setDivisionList(res?.data?.data || [])
      return res?.data?.data || [];
    } catch {
      return [];
    }
  };

  const fetchCounter = async (value: string) => {
    const company_id = getCompanyCode();
    if (!company_id) return [];

    const payload: any = {
      company_id,
      counter_code: value,
    };

    const division_code = getDivisionCode();
    if (division_code) payload.division_code = division_code;

    try {
      const res = await getCounterDetails(payload);
      setCounterList(res?.data?.data || [])
      return res?.data?.data || [];
    } catch {
      return [];
    }
  };

  const fetchProduct = async (value: string) => {
    const company_id = getCompanyCode();
    if (!company_id) return [];

    const payload: any = {
      company_id,
      search: value,
    };

    console.log(formInstance
      .getValues("division"), "hhh")

    const division_codes = getDivisionCode();
    if (division_codes) payload.division_codes = division_codes;

    try {
      const res = await getProductDetails(payload);
      setItemList(res?.data || [])
      return res?.data || [];
    } catch {
      return [];
    }
  };

  const fetchStockist = async (value: string) => {
    const company_code = getCompanyCode();
    if (!company_code) return [];

    try {
      const res = await getStockistDetails({
        company_code,
        search: value,
      });
      setStockistList(res?.data?.data?.data || [])
      return res?.data?.data?.data || [];

    } catch {
      return [];
    }
  };

  const formData = [
    {
      label: "Select Company",
      type: "autocomplete",
      id: 1,
      keyofForm: "company",
      size: "full",
      displayKey: "name",
      uniqueKey: "code",
      suggestionList: companyList,
    },
    {
      label: "Module",
      type: "autocomplete",
      id: 2,
      keyofForm: "module",
      size: "full",
      displayKey: "module_desc",
      uniqueKey: "module_code",
      suggestionList: moduleList,
    },
    {
      label: "Select Division",
      type: "autocomplete",
      id: 1,
      keyofForm: "division",
      size: "full",
      displayKey: "division_name",
      uniqueKey: "company_divisioncode",
      suggestionList: divisionList,
      isAsyncQuery: true,
      asyncListFunction: fetchDivision
    },
    {
      label: "Select Item",
      type: "autocomplete",
      id: 1,
      keyofForm: "item",
      size: "full",
      displayKey: "name",
      additionDisplayKey: "item_code",
      additionDisplayKeySearch: true,
      uniqueKey: "company_productcode",
      suggestionList: itemList,
      isAsyncQuery: true,
      asyncListFunction: fetchProduct
    },
    {
      label: "Select Counter",
      type: "autocomplete",
      id: 1,
      keyofForm: "counter",
      size: "full",
      displayKey: "counter_name",
      additionalDisplayKey: "counter_code",
      additionalDisplayKeySearch: true,
      uniqueKey: "counter_code",
      suggestionList: counterList,
      isAsyncQuery: true,
      asyncListFunction: fetchCounter
    },
    {
      label: "Select Stockist",
      type: "autocomplete",
      id: 1,
      keyofForm: "stockist",
      size: "full",
      displayKey: "firm_name",
      additionalDisplayKeySearch: true,
      additionalDisplayKey: "medvol_code",
      uniqueKey: "stockist_id",
      suggestionList: stockistList,
      isAsyncQuery: true,
      asyncListFunction: fetchStockist
    },
    {
      label: "Link Type",
      type: "autocomplete",
      id: 1,
      keyofForm: "link_type",
      size: "full",
      displayKey: "dr_ph_lnk_code",
      uniqueKey: "drph_lnk_type_id",
      suggestionList: linkTypeList,
    },
    {
      label: "Select State",
      type: "autocomplete",
      id: 1,
      keyofForm: "state",
      size: "full",
      displayKey: "state_name",
      uniqueKey: "state_code",
      suggestionList: stateList,
    },
    {
      label: "Order Type",
      type: "autocomplete",
      id: 1,
      keyofForm: "order_type",
      size: "full",
      displayKey: "label",
      uniqueKey: "value",
      suggestionList: orderTypes,
    },
    {
      label: "Reference Number",
      type: "input",
      id: 8,
      keyofForm: "reference_number",
      size: "full",
    },
  ];

  const formDefaultValues = {
    company: null,
    module: null,
    division: null,
    item: null,
    counter: null,
    stockist: null,
    link_type: null,
    state: null,
    order_type: null,
    reference_number: "",
  };

  const schema = yup.object().shape({
    company: yup
      .object()
      .nullable()
      .required("Company is required"),
    module: yup
      .object()
      .nullable()
      .required("Module is required"),
    order_type: yup
      .object()
      .nullable()
      .required("Order type is required"),
    reference_number: yup
      .string()
      .trim()
      .required("Reference number is required"),
    division: yup.object().nullable().notRequired(),
    item: yup.object().nullable().notRequired(),
    counter: yup.object().nullable().notRequired(),
    stockist: yup.object().nullable().notRequired(),
    link_type: yup.object().nullable().notRequired(),
    state: yup.object().nullable().notRequired(),
  });

  const formInstance = useForm({
    resolver: yupResolver(schema) as any,
    mode: "onBlur",
    defaultValues: formDefaultValues,
  });

  const submitHandler = async (data: any) => {
    try {
      setLoading(true);
      const payload = {
        data: {
          company_code: data.company?.code,
          company_division_code: data.division?.company_divisioncode || null,
          counter_code: data.counter?.counter_code || null,
          location_code: data?.counter?.counter_location?.[0]?.location_code,
          company_stockist_code: data.stockist?.stockist_company_lnk?.[0]?.compStockistCode || null,
          item_code: data.item?.item_code || null,
          counter_link_type: data.link_type?.dr_ph_lnk_code || null,
          module_code: data.module?.module_code || null,
          order_type: data.order_type?.label,
          cndn_remarks_code: data.order_type?.value,
          reference_number: data.reference_number,
          metadata: {
            states: data.state
              ? [
                {
                  stateCode: data.state.state_code,
                },
              ]
              : [],
          },
          activeStatus: "Yes",
          ucode: generateUniqueID()
        },
        event_type: "ORDER_TYPE_EXCEPTION_ADD",
      };

      const response = await addOrderTypeException(payload)
      if (response?.data?.status === 200) {
        toast({
          variant: "default",
          description: "Order Type Exception added successfully"
        })
        formInstance.reset();
        onClose();
      } else {
        throw new Error(response?.data?.message || "Something went wrong");
      }
    } catch (error: any) {
      let message = "Error adding Order Type Exception";
      if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error?.message) {
        message = error.message;
      }
      toast({
        variant: "default",
        description: message
      })
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isHeader={true}
      isOpen={true}
      onCloseModal={onClose}
      title="Add Order Type Exception"
      onBack={() => {
      }}
    >
      <SmartForm
        defaultValues={formDefaultValues}
        isControlled={false}
        schema={schema}
        onFormSubmit={submitHandler}
        formInstance={formInstance}
      >
        <div className="p-6 w-[51rem] grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-4">
          {formData.map(
            ({
              label,
              type,
              id,
              placeholder,
              fieldType,
              keyofForm,
              suggestionList,
              displayKey,
              unique_key,
              asyncListFunction,
            }: any) => {
              switch (type.toString().toLocaleLowerCase().trim()) {
                case "autocomplete":
                  return (
                    <Fragment key={id}>
                      <div className="w-full">
                        <SmartForm.Autocomplete
                          fieldName={keyofForm}
                          label={label}
                          fieldType={fieldType}
                          suggestionList={suggestionList || []}
                          displayKey={displayKey}
                          asyncListFunction={asyncListFunction ? asyncListFunction : undefined}
                          uniqueKey={unique_key}
                          placeholder={placeholder || ""}
                          key={id}
                          className="w-full"
                        />
                      </div>
                    </Fragment>
                  );
                default:
                  return (
                    <SmartForm.Input
                      type={type}
                      placeholder={placeholder || ""}
                      label={label}
                      key={id}
                      fieldName={keyofForm}
                      className="w-full mr-auto"
                      inputClassName="w-full"
                    />
                  );
              }
            }
          )}
          <div className="flex justify-end w-full col-span-1 gap-2 pt-4 sm:col-span-2">
            <Button className="gap-2 border" onClick={onClose}>
              Cancel
            </Button>
            <Button type="submit" className="bg-[#7F56D9] text-white" isLoading={loading} loaderSize="small">
              Create
            </Button>
          </div>
        </div>
      </SmartForm>
    </Modal>
  );
}

export default OrderTypeExceptionForm;


